import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14.296 1 .704.708L10.707 6H14v1H9V2h1v3.293zM2 10V9h5v5H6v-3.293L1.707 15 1 14.291 5.293 10z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }